var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-img',{staticStyle:{"position":"absolute","max-width":"50vw"},attrs:{"src":require('@/assets/dotted_bck.png')}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }